/**
 * Shared Tailwind classes for the chat's bottom-slot pill UI.
 * Used by both ChatQuickActions (empty-state starters) and
 * ChatQuickReplyBar (contextual LLM-provided chips) so the two look
 * indistinguishable to the user.
 */

export const QUICK_ACTION_BAR_CLASS = "flex flex-col gap-2 pb-3 pt-4 animate-fade-in";

export const QUICK_ACTION_PILL_CLASS =
  "w-full py-3 px-4 rounded-lg bg-surface-container hover:bg-surface-container-high " +
  "text-primary font-medium text-sm text-left transition-all";
